import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ConnectAnalytics } from '@ahmdigital/ui';
import { ConnectedRouter as ConnectedNextRouter } from 'connected-next-router';
import { History } from 'history';
import { isUndefined } from 'lodash/fp';
import { ReactNode, useEffect } from 'react';

import analytics from '../../analytics';
import DrawerActions from '../../actions/drawer';
import getIsServer from '../../utils/get-is-server';
import getMemberNumber from '../../utils/get-oms-member-number';
import HistoryActions from '../../actions/history';
import RequestACall from '../../actions/request-a-call';

type CustomRouterProps = {
  actions: {
    drawer: {
      closeDrawer: (...args: unknown[]) => unknown;
    };
    history: {
      push: (...args: unknown[]) => unknown;
    };
    requestACall: {
      checkRules: (...args: unknown[]) => unknown;
    };
  };
  children: ReactNode;
  history: History;
};

const CustomRouter = ({ actions, children, history }: CustomRouterProps) => {
  useEffect(() => {
    // @ts-expect-error - Automatic, Please fix when editing this file
    const historyEventHandler = (location) => {
      const isServer = getIsServer();
      if (!isServer && !location.hash) {
        actions.history.push(location.pathname);

        const isNotAMember = isUndefined(getMemberNumber());
        if (isNotAMember) {
          actions.requestACall.checkRules();
        }
      }
    };

    // Run this once the first time the component loads
    historyEventHandler(history.location);

    // We return the result of this because it returns a function that removes the event listener, which this hook will call on unmount
    return history.listen((location) => {
      if (!location.hash) {
        window.scrollTo(0, 0);
        document.body.focus();
      }

      actions.drawer.closeDrawer();

      historyEventHandler(location);
    });
  }, [actions, history]);

  return (
    <ConnectAnalytics publish={analytics.publish}>
      {/* @ts-expect-error - Automatic, Please fix when editing this file */}
      <ConnectedNextRouter history={history}>{children}</ConnectedNextRouter>
    </ConnectAnalytics>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  actions: {
    drawer: bindActionCreators(DrawerActions, dispatch),
    history: bindActionCreators(HistoryActions, dispatch),
    requestACall: bindActionCreators(RequestACall, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(CustomRouter);

export { CustomRouter as CustomRouterForTest, mapDispatchToProps };
